<template>
    <div class="embed-container">
        <div class="has-text-centered" v-html="embed"></div>
    </div>
</template>

<script>
export default {
    props: {
        embed: {
            type: String,
            default: undefined,
        },
    },
     mounted: function () {
        /*console.log("embed",this.embed)
        const container=document.getElementsByClassName("embed-container");
        console.log(container[0].clientWidth)
        const iframeHeight = (9/16)*container[0].clientWidth;
        console.log(iframeHeight,parseInt(iframeHeight))
        let iframe=document.getElementsByTagName("iframe");
        console.log(iframe[0].style)
        iframe[0].setAttribute("width",container[0].clientWidth);*/
        //iframe[0].style.maxWidth = container[0].clientWidth+"px";

    }
};

</script>

<style >
    .embed-container iframe{
        max-width: -webkit-fill-available;
        max-width: stretch;
    }
</style>
